export default __webpack_public_path__ + "static/media/Wolf's Leggings of World's Edge.62dc7d66.jpg";